import { render, staticRenderFns } from "./CloneScene.vue?vue&type=template&id=b86c2548&scoped=true"
import script from "./CloneScene.vue?vue&type=script&lang=js"
export * from "./CloneScene.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86c2548",
  null
  
)

export default component.exports